export default __webpack_public_path__ + "static/media/bg-dotted.2d17a3ed.svg";